var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"left-right-wrapper"},[_c('LeftRight',{attrs:{"leftColor":_vm.block.leftColor,"rightColor":_vm.block.rightColor,"threhshold":_vm.block.threshold,"debug":_vm.ShowDebugger},on:{"change":function($event){return _vm.UpdateLeftRight($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }